module.exports = __webpack_public_path__ + "static/media/login.d0072cb1.svg";